export const useIsMobile = (): { isMobile: boolean } => {
  const isMobile =
    typeof window !== "undefined"
      ? /Android|iPhone|iPad|iPod|BlackBerry|Opera Mini/i.test(
          navigator.userAgent,
        )
      : false;

  return { isMobile };
};
